import React from "react";
import _ from "lodash";
import numeral from "numeral";
import {
  parseTableData,
  filterDataToGroup,
} from "../IntegrationVerificationHelper";
import GroupDataTable from "./GroupDataTable";
import FilterControl from "./FilterControl";

class ActiveCtrView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      columns: [],
      groups: [],

      filterGroups: [],
      filterRecords: [],
      filterAmount: null,

      tags: [],
      alias: [],
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    const { records, columns } = this.props;
    const newRecords = [];
    const newColumns = [
      columns[0],
      columns[1],
      "b_total_eligible_imp",
      "b_total_viewable_imp",
      "b_adx_eligible_imp",
      "b_adx_viewable_imp",
      "b_adx_ctr",
      "o_total_eligible_imp",
      "o_total_viewable_imp",
      "o_adx_eligible_imp",
      "o_adx_viewable_imp",
      "o_adx_ctr",
      "total_eligible_imp",
      "total_imp",
    ];

    const dateIdx = _.indexOf(columns, "date");
    const idIdx = _.indexOf(columns, "ext_gam_unit_id");
    const groupIdx = _.indexOf(columns, "group_type");
    const dateList = _.union(_.map(records, (item) => item[dateIdx]));
    const idList = _.union(_.map(records, (item) => item[idIdx]));

    _.forEach(dateList, (date) => {
      _.forEach(idList, (id) => {
        const bItem = _.find(records, (item) => {
          return (
            item[dateIdx] === date &&
            item[idIdx] === id &&
            item[groupIdx] === "b"
          );
        });
        const oItem = _.find(records, (item) => {
          return (
            item[dateIdx] === date &&
            item[idIdx] === id &&
            item[groupIdx] === "o"
          );
        });

        const bList = bItem ? bItem.slice(3) : Array(5).fill(0);
        const oList = oItem ? oItem.slice(3) : Array(5).fill(0);

        newRecords.push([
          date,
          id,
          ...bList,
          ...oList,
          bList[0] + oList[0],
          _.sum(bList.slice(0, 2)) + _.sum(oList.slice(0, 2)),
        ]);
      });
    });

    const arrangeCol = [
      {
        key: "ext_gam_unit_id",
        label: "Ext Gam Unit Id",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "date",
        label: "Date",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "total_eligible_imp",
        label: "total eligible imp.",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "b_adx_ctr",
        label: "adx ctr",
        group: "b",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "b_total_viewable_imp",
        label: "total imp.",
        group: "b",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "b_total_eligible_imp",
        label: "total eligible imp.",
        group: "b",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "b_adx_eligible_imp",
        label: "-",
        hide: true,
        groupfunc: (list) => {
          return _.sum(list);
        },
      },
      {
        key: "b_adx_viewable_imp",
        label: "-",
        hide: true,
        groupfunc: (list) => {
          return _.sum(list);
        },
      },
      {
        key: "b_total_percent",
        label: "total %",
        group: "b",
        parsefunc: ({ b_total_viewable_imp, b_total_eligible_imp }) => {
          return b_total_viewable_imp / b_total_eligible_imp;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "b_adx_percent",
        label: "adx %",
        group: "b",
        parsefunc: ({ b_adx_eligible_imp, b_adx_viewable_imp }) => {
          return b_adx_viewable_imp / b_adx_eligible_imp;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "o_adx_ctr",
        label: "adx ctr",
        group: "o",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "o_total_viewable_imp",
        label: "total imp.",
        group: "o",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "o_total_eligible_imp",
        label: "total eligible imp.",
        group: "o",
        groupfunc: (list) => {
          return _.sum(list);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "o_adx_eligible_imp",
        label: "-",
        hide: true,
        groupfunc: (list) => {
          return _.sum(list);
        },
      },
      {
        key: "o_adx_viewable_imp",
        label: "-",
        hide: true,
        groupfunc: (list) => {
          return _.sum(list);
        },
      },
      {
        key: "o_total_percent",
        label: "total %",
        group: "o",
        parsefunc: ({ o_total_viewable_imp, o_total_eligible_imp }) => {
          return o_total_viewable_imp / o_total_eligible_imp;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "o_adx_percent",
        label: "adx %",
        group: "o",
        parsefunc: ({ o_adx_eligible_imp, o_adx_viewable_imp }) => {
          return o_adx_viewable_imp / o_adx_eligible_imp;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "o_b_adx_ctr",
        label: "adx ctr",
        group: "o vs b",
        parsefunc: ({ o_adx_ctr, b_adx_ctr }) => {
          return o_adx_ctr - b_adx_ctr;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "o_b_total_percent",
        label: "total %",
        group: "o vs b",
        parsefunc: ({ o_total_percent, b_total_percent }) => {
          return b_total_percent === 0
            ? 0
            : (o_total_percent - b_total_percent) / b_total_percent;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "o_b_adx_percent",
        label: "adx %",
        group: "o vs b",
        parsefunc: ({ o_adx_percent, b_adx_percent }) => {
          return b_adx_percent === 0
            ? 0
            : (o_adx_percent - b_adx_percent) / b_adx_percent;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
    ];

    const result = parseTableData({
      columns: newColumns,
      arrangeColumns: arrangeCol,
      records: newRecords,
      mainKey: "ext_gam_unit_id",
      orderKey: "total_imp",
    });

    this.setState({
      ...result,
      columns: arrangeCol,
      filterGroups: result.groups,
      filterRecords: result.records,
      filterAmount: result.amount,
      tags: arrangeCol.slice(2).map((item) => ({
        value: item.key,
        label: item.label,
        hide: item.hide,
        group: item.group,
      })),
      alias: [
        {
          value:
            "total_eligible_imp >= 10000 AND ((o_b_adx_ctr <= -0.01 OR o_b_adx_ctr >= 0.01)  OR (o_b_total_percent <= -0.01 OR o_b_total_percent >= 0.01)  OR (o_b_adx_percent <= -0.01 OR o_b_adx_percent >= 0.01))",
          label: "Quick Filter",
        },
        {
          func: (inputValue) => {
            const lower = (inputValue - 0.01).toFixed(2);
            const upper = (inputValue + 0.01).toFixed(2);
            return `total_eligible_imp >= 10000 AND ((o_b_adx_ctr <= ${lower} OR o_b_adx_ctr >= ${upper})  OR (o_b_total_percent <= ${lower} OR o_b_total_percent >= ${upper})  OR (o_b_adx_percent <= ${lower} OR o_b_adx_percent >= ${upper}))`;
          },
          label: "Custom Rate",
        },
      ],
    });
  }

  handleSearch(expression) {
    const { records, columns } = this.state;

    const result = filterDataToGroup({
      expression,
      records,
      columns,
    });

    if (result) {
      this.setState({
        ...result,
      });
    }
  }

  render() {
    const { columns, tags, filterAmount, filterGroups, filterRecords, alias } =
      this.state;
    return (
      <>
        <div className="mb-2">
          <FilterControl
            tags={tags}
            alias={alias}
            handleSearch={this.handleSearch}
          ></FilterControl>
        </div>
        <div className="w-full overflow-x-auto">
          <GroupDataTable
            records={filterRecords}
            groups={filterGroups}
            amount={filterAmount}
            columns={columns}
            mainKey="ext_gam_unit_id"
            header={
              <tr className="bg-gray-100">
                <th className="border px-2 py-1 text-center" colSpan={4}></th>
                <th className="border px-2 py-1 text-center" colSpan={5}>
                  b
                </th>
                <th className="border px-2 py-1 text-center" colSpan={5}>
                  o
                </th>
                <th className="border px-2 py-1 text-center" colSpan={3}>
                  o vs b
                </th>
              </tr>
            }
          ></GroupDataTable>
        </div>
      </>
    );
  }
}
export default ActiveCtrView;
